import * as React from 'react';
import { SVGProps } from 'react';
const SvgComponent = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={99}
    height={34}
    viewBox="0 0 99 34"
    fill="none"
    {...props}
  >
    <mask
      id="mask0_2809_42500"
      style={{ maskType: 'alpha' }}
      maskUnits="userSpaceOnUse"
      x="0"
      y="0"
      width="34"
      height="34"
    >
      <circle cx="17" cy="17" r="17" fill="#D9D9D9" />
    </mask>
    <g mask="url(#mask0_2809_42500)">
      <rect width="34" height="8.5" fill="#4066C9" />
      <rect y="8.50008" width="34" height="8.5" fill="#EC450D" />
      <rect y="25.4999" width="34" height="8.5" fill="#10A35D" />
      <rect y="17.0001" width="34" height="8.5" fill="#FFA50A" />
    </g>
    <path
      d="M38.3906 25.5154H41.1466V23.975C41.8927 24.8252 42.9535 25.9291 45.3694 25.9291C49.955 25.9291 51.602 21.6302 51.602 19.0772C51.602 15.697 49.1176 12.3167 45.3008 12.3167C43.9 12.3167 42.4332 12.8446 41.3928 13.9028V8.5H38.3906V25.5154ZM41.2151 18.963C41.2151 17.1003 42.6388 15.1235 44.943 15.1235C46.8412 15.1235 48.6024 16.6182 48.6024 19.1001C48.6024 21.582 46.9529 23.1249 44.9887 23.1249C43.2275 23.1249 41.2176 21.7901 41.2176 18.963H41.2151Z"
      fill="currentColor"
    />
    <path
      d="M64.928 20.5031C65.0193 20.0895 65.1081 19.5616 65.1081 18.9627C65.1081 15.7449 62.7354 12.3164 58.6268 12.3164C54.5182 12.3164 52.0312 15.5596 52.0312 19.1683C52.0312 22.7769 54.8329 25.9288 58.6496 25.9288C61.6086 25.9288 63.9789 23.7895 64.7021 21.4903H61.5401C60.9742 22.5485 59.9819 23.122 58.6496 23.122C56.5027 23.122 55.3303 21.3279 55.1933 20.5006H64.928V20.5031ZM55.1019 18.044C55.6653 15.6764 57.429 15.1231 58.6471 15.1231C60.2509 15.1231 61.6974 15.9961 62.035 18.044H55.1019Z"
      fill="currentColor"
    />
    <path
      d="M78.7211 12.7528H75.9652V14.3617H75.9195C75.8281 14.179 74.3157 12.3163 71.7627 12.3163C68.2835 12.3163 65.4844 15.1433 65.4844 19.054C65.4844 23.3072 68.352 25.9287 71.5825 25.9287C73.1635 25.9287 75.0161 25.0785 75.9652 23.9289V25.515H78.7211V12.7528ZM75.8764 19.0996C75.8764 21.4673 74.2954 23.1245 72.217 23.1245C70.1386 23.1245 68.489 21.3531 68.489 19.1935C68.489 17.2852 69.7528 15.123 72.217 15.123C74.001 15.123 75.8764 16.4579 75.8764 19.0996Z"
      fill="currentColor"
    />
    <path
      d="M80.1094 25.5184H83.114V19.1487C83.114 17.7911 83.114 15.1239 85.5071 15.1239C87.3596 15.1239 88.0144 16.6872 88.0144 18.4356V25.5184H91.019V19.1487C91.019 18.3443 90.9962 17.0805 91.4708 16.3217C91.8996 15.5858 92.7142 15.1265 93.5492 15.1265C95.9219 15.1265 95.9219 17.7022 95.9219 18.4382V25.521H98.9266V18.0702C98.9266 16.1847 98.4749 14.9666 97.9775 14.2992C97.5258 13.6546 96.3051 12.3223 93.8435 12.3223C92.9629 12.3223 91.1104 12.4136 89.8009 14.322C88.626 12.4821 86.8648 12.3223 86.1872 12.3223C84.02 12.3223 83.1597 13.4262 82.911 13.8398H82.8653V12.7588H80.1094V25.521V25.5184Z"
      fill="currentColor"
    />
  </svg>
);
export default SvgComponent;
